import { UserContext } from '@providers/userContextProvider';
import { useContext } from 'react';

export const useFeatureFlagsResolved = () => {
  const { featureFlagsResolved } = useContext(UserContext);

  return featureFlagsResolved;
};
